import React from "react";
import { useSelector } from "react-redux";

const ServiceStatistics = (  ) => {
    var  {  tickets  }  =  useSelector((state) => state.queueManagement);

   var  inQueue  =  tickets !== null ? tickets?.filter(ticket=>{ return ticket.status === 0}).length : 0
   var  active  =  tickets !== null ? tickets?.filter(ticket=>{ return ticket.status === 1}).length : 0
  var  noShow  =  tickets !== null ? tickets?.filter(ticket=>{ return ticket.status === 2}).length : 0
  var  completed  =  tickets !== null ? tickets?.filter(ticket=>{ return ticket.status === 3}).length : 0
  var  suspended  =  tickets !== null ? tickets?.filter(ticket=>{ return ticket.status === 4 }).length : 0

   return (
       
    <div class="row g-4 mb-4">
    <div class="col-sm-6 col-xl-3">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-start justify-content-between">
            <div class="content-left">
              <span>Completed tickets</span>
              <div class="d-flex align-items-end mt-2">
                <h4 class="mb-0 me-2">{completed } / { tickets.length || 0 } </h4>
               </div>
             </div> 
          </div>
        </div>
      </div>
    </div>
 
    <div class="col-sm-6 col-xl-3">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-start justify-content-between">
            <div class="content-left">
              <span>In queue &amp; active</span>
              <div class="d-flex align-items-end mt-2">
                <h4 class="mb-0 me-2">{active} / {inQueue}</h4>
               </div>
             </div> 
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-xl-3">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-start justify-content-between">
            <div class="content-left">
              <span>No show</span>
              <div class="d-flex align-items-end mt-2">
                <h4 class="mb-0 me-2">{noShow}</h4>
               </div>
             </div> 
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-xl-3">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-start justify-content-between">
            <div class="content-left">
              <span>Lost</span>
              <div class="d-flex align-items-end mt-2">
                <h4 class="mb-0 me-2">{suspended}</h4>
               </div>
             </div> 
          </div>
        </div>
      </div>
    </div>
  </div>
   );
};

export default ServiceStatistics;
